<script setup lang="ts">
import { ref } from 'vue'
import IconComponent from '../common/IconComponent.vue';
import NotificationDrawer from './NotificationDrawer.vue';

const hasNotifications = ref(true)
const isDrawerOpen = ref(false)

const toggleDrawer = () => {
  isDrawerOpen.value = !isDrawerOpen.value
}
</script>

<template>
  <div>
    <button
      @click="toggleDrawer"
      class="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors relative"
      title="Notifications"
    >
      <IconComponent name="BellRing" />
      <span
        v-if="hasNotifications"
        class="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"
      ></span>
    </button>
    
    <NotificationDrawer
      :is-open="isDrawerOpen"
      @close="isDrawerOpen = false"
    />
  </div>
</template>